import Button from '@material-ui/core/Button'
import Home from '@material-ui/icons/Home'
import Paper from '@material-ui/core/Paper'
import React from 'react'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import MinimalLayout from '../../Backbone/layout/MinimalLayout'



const useStyles = makeStyles((theme) => ({
    icon: {
        width: 192,
        height: 192,
        color: theme.palette.secondary.main,
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justify: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.default,
        margin: 0,
    },
    button: {
        marginTop: 20,
    },
}))

const PageNotFound = () => {

    const classes = useStyles()

    return (
        <MinimalLayout>
            <Paper className={classes.paper}>
                <div className={classes.container}>
                    <Typography variant="h4">404</Typography>
                    <Typography variant="subtitle1">
                        Hey, it's looks like you take a wrong move!! Click below to return Home!!
                    </Typography>
                    <Button
                        color="secondary"
                        aria-label="home"
                        href="/"
                        className={classes.button}
                    >
                        <Home />
                    </Button>
                </div>
            </Paper>
        </MinimalLayout>
    )
}

export default PageNotFound